<template>
    <AuthLayout>
        <div
            class="mt-8 flex w-full flex-col items-center overflow-hidden bg-white p-6 shadow-xl sm:mt-14 sm:max-w-md sm:rounded-lg"
        >
            <div class="-mt-1 h-[240px] w-[240px]">
                <img
                    srcset="
                        https://d5aoblv5p04cg.cloudfront.net/application/images/auth/forgotten-confirmation.png
                    "
                    class="ml-[10px] mt-[10px] h-full w-full"
                    alt="Rhizom Illustration"
                />
            </div>

            <div class="mt-[14px] text-xl font-bold text-gray-800">
                {{ $t("vue.all_good") }}
            </div>

            <div class="mt-3 max-w-sm text-center text-sm text-gray-500">
                {{ $t("vue.new_password_set_sign_in") }}
            </div>

            <div class="mb-3 mt-9 w-full">
                <inertia-link :href="route('login')">
                    <MegaButton>{{ $t("vue.sign_in") }}</MegaButton>
                </inertia-link>
            </div>
        </div>
    </AuthLayout>
</template>

<script lang="ts" setup>
import route from "ziggy-js";
</script>
